import React, { memo, useCallback } from "react";

import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { Body } from "capitalrx-components-2.0/lib/typography";
import cn from "classnames";

import { ToggleProps } from "./Toggle.props";

import styles from "./Toggle.module.scss";

const Toggle: React.FC<ToggleProps> = (props: ToggleProps) => {
  const {
    id,
    toggleLabel, // text to the right
    tabIndex,
    onChange,
    name,
    containerClassName,
    isChecked,
  } = props;

  const toggleContainerClass = cn(containerClassName);

  const handleToggleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>): void => {
      onChange && onChange(e);
    },
    [onChange],
  );

  return (
    <div className={toggleContainerClass}>
      <div className={styles["toggle-outer"]}>
        <div className={styles["toggle-container"]}>
          <Shelf spacing="small">
            <div className={styles["toggle"]}>
              <input
                tabIndex={tabIndex}
                aria-label={typeof toggleLabel === "string" ? toggleLabel : undefined}
                type="checkbox"
                id={id ? `toggle_${name}_${id}` : undefined}
                data-testid={`test__${id}`}
                checked={isChecked}
                onChange={(e): void => handleToggleChange(e)}
              />
              <div className={cn(styles["slider"], styles["round"], styles["toggle"])}></div>
            </div>
            {typeof toggleLabel === "string" && (
              <label
                aria-label={toggleLabel}
                htmlFor={`toggle_${name}_${id}`}
                data-testid={`test__${id}-label`}
                className={styles["toggle-label"]}
              >
                <Body size="small">{toggleLabel}</Body>
              </label>
            )}
            {typeof toggleLabel !== "string" && toggleLabel}
          </Shelf>
        </div>
      </div>
    </div>
  );
};

export default memo(Toggle);
